export default "__VITE_ASSET__abaadd0c__"